import _defineProperty from "/codebuild/output/src343154253/src/AWSAmplifyTest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/codebuild/output/src343154253/src/AWSAmplifyTest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/codebuild/output/src343154253/src/AWSAmplifyTest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { Slot as e } from "@radix-ui/react-slot";
import * as r from "react";
import t from "@babel/runtime/helpers/esm/extends";
export var Primitive = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (o, i) {
  return _objectSpread({}, o, _defineProperty({}, i, /*#__PURE__*/r.forwardRef(function (o, m) {
    var a = o.asChild,
      s = _objectWithoutProperties(o, ["asChild"]),
      n = a ? e : i;
    return r.useEffect(function () {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /*#__PURE__*/r.createElement(n, t({}, s, {
      ref: m
    }));
  })));
}, {});
export var Root = Primitive;